/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * This file make it easier to mock calls to new relic
 * while running unit tests.
 */

const noticeError = (err: Error): void => {
  try {
    ;(globalThis as any).window.newrelic.noticeError(err)
  } catch {
    console.warn('Unable to log error to new relic')
  }
}

const setCustomAttribute = (attributeName: string, attributeValue: string): void => {
  try {
    ;(globalThis as any).window.newrelic.setCustomAttribute(attributeName, attributeValue)
  } catch {
    console.warn('Failed to set custom attributes for NewRelic.')
  }
}

export { noticeError, setCustomAttribute }
